import React from "react";

function OrderItemHeader() {

  return (
    <>
      <div className="legenda_ordine">
        <div className="legenda_articoli_ordine">
          <p>Prodotti</p>
        </div>
        <div className="legenda_prezzo_ordine">
          <p>Prezzo</p>
        </div>
        <div className="legenda_qta_ordine">
          <p>Quantità</p>
        </div>
        <div className="legenda_totale_ordine">
          <p>Totale</p>
        </div>
      </div>
      <div className="AW-clear"></div>
    </>
  );
}

export default OrderItemHeader;
